import { Col, Divider, Row, Text, Link } from "@nextui-org/react";
import React from "react";
import DocumentStats from "./DocumentStats";
import IntegrationStats from "./IntegrationStats";
import OtherStats from "./OtherStats";
import StopRatings from "./StopRatings";
import TrendArtifax from "./TrendArtifax";

const CurrentData = ({ clientId }) => {
  return (
    <div className="h-full w-full">
      <Row justify="space-between" gap={1} className="py-4">
        <Col>
          <IntegrationStats clientId={clientId} />
        </Col>
        <Col>
          <DocumentStats clientId={clientId} />
        </Col>
        <Col>
          <OtherStats clientId={clientId} />
        </Col>
      </Row>
      
      <Divider className="my-6" />
      
      <Row justify="space-between" className="py-6 pl-4">
        <Col span={5}>
          <Text size={20}>
            Stop Ratings
            <Link className="ml-2.5" href="/driver/location-analytics">
              (Detailed report)
            </Link>
          </Text>
          <StopRatings clientId={clientId} />
        </Col>
        <Col span={7}>
          <Text className="pl-5" size={20}>
            Shipment Trends (Last 7 days)
          </Text>
          <TrendArtifax clientId={clientId} />
        </Col>
      </Row>
    </div>
  );
};

export default CurrentData;